/**
 * Checkbox toggle tiện ích (boolean) trong form BĐS admin.
 */

/**
 * Field bật/tắt tiện ích.
 * @param {Object} props
 * @param {string} props.label
 * @param {boolean} props.checked
 * @param {Function} props.onChange
 */
export const AmenityToggleField = ({ label, checked, onChange }) => (
  <label className={`room-spec-field room-spec-field--toggle-only ${checked ? 'is-active' : ''}`.trim()}>
    <span className="room-spec-main">
      <input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} />
      <span className="room-spec-label">{label}</span>
    </span>
  </label>
);
